module.exports = __webpack_public_path__ + "pc/img/MO_thumbnail_480x316.1bc97618.png";